import { Turbo } from "@hotwired/turbo-rails"

const htmlFetch = async (url, { headers = {}, ...options } = {}) => {
  const defaultHeaders = {
    "X-CSRF-Token": csrfToken(),
  }

  const response = await fetch(url, {
    headers: { ...defaultHeaders, ...headers },
    credentials: "same-origin",
    ...options,
  })

  const contentType = response.headers.get("Content-Type")
  const html = await response.text()

  if (contentType?.includes("turbo-stream")) {
    Turbo.renderStreamMessage(html)
  } else if (response.redirected) {
    Turbo.visit(response.url)
  }

  return response
}

const turboFetch = async (url, { headers, ...options } = {}) => {
  return htmlFetch(url, {
    headers: {
      Accept: "text/vnd.turbo-stream.html",
      ...headers,
    },
    ...options,
  })
}

const turboSubmit = async (url, { method = "post", body = {} } = {}) => {
  const formData = new FormData()

  // Add _method for Rails method override
  if (method.toLowerCase() !== "post") {
    formData.append("_method", method.toLowerCase())
  }

  // Add any additional body data
  Object.entries(body).forEach(([key, value]) => {
    formData.append(key, value)
  })

  return htmlFetch(url, {
    method: "POST",
    headers: {
      Accept: "text/vnd.turbo-stream.html, text/html",
    },
    body: formData,
  })
}

const csrfToken = () => {
  return document.querySelector("meta[name=\"csrf-token\"]").content
}

export { turboFetch, turboSubmit }
